export const API_URL = `${process.env.WP_BASE_URL}/graphql`
export const GLOBAL_SEARCH_URL = `${API_URL}/graphql`
export const EVENTS_SEARCH_URL = `${API_URL}/graphql`
export const LOCATIONS_SEARCH_URL = `${API_URL}/graphql`
